<template>
  <Modal
    v-model:show="active"
    class="modal-password component-password"
    @close="close"
  >
    <template v-slot:header>
      <h5 class="modal-title">
        {{ title }}
      </h5>
    </template>

    <form :disabled="$store.state.errors.loading">
      <div class="modal__body">
        <div
          v-if="!label"
          class="modal__body-up mb-24"
        >
          <h1>
            <img
              :src="lockImg"
              alt="lock"
            >
          </h1>
          <span>
            {{ $t('alerts.passwordDialog.message') }} {{ $store.state.profile.user.email }}
          </span>
        </div>
        <UiInput
          v-model="password"
          v-model:error="errMessage"
          class="mb-12"
          :label="label || $t('alerts.passwordDialog.label')"
          type="password"
          placeholder="********"
          error-clear-on-change
        />
      </div>
    </form>

    <template v-slot:footer>
      <div class="component-password__footer mt-8">
        <button
          class="btn btn-outline-primary btn-sm modal__btn-cancel"
          @click="close"
        >
          {{ $t('alerts.passwordDialog.cancel') }}
        </button>
        <button
          :disabled="!valid || isLoading"
          class="btn btn-primary btn-sm modal__btn-confirm ml-8"
          @click="enter"
        >
          <span v-if="!$store.state.errors.loading">
            {{ $t('alerts.passwordDialog.confirm') }}
          </span>
          <i
            v-if="$store.state.errors.loading"
            class="fas fa-spinner spinner-hide"
          />
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal } from '@/components';

import lockImg from '@/assets/theme/icon/lock.svg';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      password: '',
      passwords: '',
      active: false,
      invalid: false,
      callback: new Function(),
      onclose: new Function(),
      title: 'Disable Two-Factor Authentication',
      label: '',
      comment: null,
      complete: false,
      disabled: false,
      errMessage: '',
      min: 8,
      isLoading: false,
    };
  },
  computed: {
    lockImg: () => lockImg,
    valid() {
      return this.password.length >= (this.min || 8);
    },
  },
  methods: {
    open(options) {
      const {title, comment, callback, onclose, label, min} = options;
      this.title = title || this.title;
      this.label = label || this.label;
      this.comment = comment;
      this.callback = callback;
      this.onclose = onclose || new Function();
      this.active = true;
      this.min = min || 8;
      document.addEventListener('keydown', this.keydownListener, true);
    },
    close() {
      this.active = false;
      this.title = 'Disable Two-Factor Authentication';
      this.comment = '';
      this.callback = new Function();
      this.onclose = new Function();
      this.password = '';
      this.errMessage = '';
      this.label = '';
      this.disabled = true;
      this.$event.$emit('forms/reset');
      document.removeEventListener('keydown', this.keydownListener, true);
    },
    keydownListener(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        if (this.valid) this.enter();
      }
    },
    enter() {
      if (!this.password && !this.valid) {
        return;
      }
      if (this.callback) {
        this.callback(this.password, this);
      }
    },
  },
};
</script>

<style lang="scss">
@import 'styles/password';
</style>
